import debounce from '@mui/utils/debounce';
export default debounce;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/utils/debounce.js
// module id = 233
// module chunks = 25